import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.css']
})
export class SearchBoxComponent implements OnInit {

  constructor(private _router: Router, private modalService: NgbModal) { }

  searchText: string = "";
  ngOnInit(): void {}

  redirect(arg) {
    if (arg != '') {
      this._router.navigate(['search/' + encodeURIComponent(arg)])
      this.modalService.dismissAll();
    }
  }
}
